import {subDays, subMonths, subWeeks} from 'date-fns';

/* Asset */

export function isNew(date) {
	if (date === null || date === undefined) {
		return false;
	} else {
		const createdDate = new Date(date);
		const now = new Date();
		const tenMinutesInMs = 1000 * 60 * 10;

		if (now.getTime() - tenMinutesInMs < createdDate.getTime()) {
			return 'just';
		}
		if (now.toLocaleDateString() === createdDate.toLocaleDateString()) {
			return 'today';
		} else {
			return false;
		}
	}
}
export function addhttps(url) {
	const reg = /^((http|https|ftp):\/\/)/;
	if (!reg.test(url)) {
		url = 'https://' + url;
	}
	return url;
}

export function subtractPeriod(period) {
	// Get the current date.
	const date = new Date();

	switch (period) {
		case 'day':
			return subDays(date, 1);
		case 'week':
			return subWeeks(date, 1);
		case 'month':
			return subMonths(date, 1);
		case 'year':
			return subMonths(date, 12);
	}
}

export function pad(n, width, z) {
	z ||= '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}
